import React, { useState } from 'react';
import api from '../utils/api';
import { FileText } from 'lucide-react';
import { toast } from 'sonner';

const PDFExportButton = ({ endpoint, filename, label = 'Export PDF' }) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      const response = await api.get(endpoint, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename || 'export.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error('PDF export failed');
    } finally { setExporting(false); }
  };

  return (
    <button onClick={handleExport} className="btn btn-secondary btn-sm" disabled={exporting} data-testid="export-pdf-btn">
      <FileText size={14} /> {exporting ? 'Exporting...' : label}
    </button>
  );
};

export default PDFExportButton;
